"use strict";

require("core-js/modules/es.object.assign.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _styles = require("@mui/material/styles");
var _constants = require("../../utils/constants");
const _excluded = ["index"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const StyledTab = (0, _styles.styled)(_material.Tab)({
  maxWidth: 'none',
  minHeight: 36.5,
  height: 36.5,
  color: _constants.colors['main-color-cl-01'],
  fontFamily: "'Ubuntu', sans-serif",
  fontSize: 20,
  lineHeight: 30,
  textTransform: 'none',
  opacity: 0.25,
  padding: '0 30px',
  borderBottom: "2px solid ".concat(_constants.colors['main-color-cl-30']),
  transition: 'all 0.3s ease',
  '&.Mui-selected': {
    color: _constants.colors['main-color-cl-01']
  }
});
const a11yProps = value => ({
  id: "tab-".concat(value),
  'aria-controls': "tabpanel-".concat(value)
});
const Tab = props => {
  const {
      index
    } = props,
    other = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_react.default.createElement(StyledTab, _extends({}, other, a11yProps(index)));
};
var _default = exports.default = Tab;